import { IMAGES } from "./services";

export const LOCATIONS = [
  {
    slug: "massachusetts",
    state: "Massachusetts",
    image: IMAGES.server_rack,
    imageAlt: "A small Massachusetts business team working on laptops",
    cities: ["Boston", "Worcester", "Springfield", "Cambridge", "Lowell", "Quincy"],
    intro:
      "From Boston's professional services corridor to manufacturers in Worcester and practices in Springfield, Massachusetts small businesses run on systems that can't afford a bad day. Sempresera delivers the full standard across the Commonwealth — 24/7 monitoring, Huntress-powered security, Microsoft 365 management and tested backups — with genuine on-site support, because Massachusetts is our home turf.",
    metaTitle: "Managed IT Services in Massachusetts | Sempresera",
    metaDescription:
      "Managed IT, cybersecurity, Microsoft 365 and help desk support for Massachusetts small businesses — Boston to Springfield. On-site service, one all-inclusive standard.",
  },
  {
    slug: "connecticut",
    state: "Connecticut",
    image: IMAGES.office_team,
    imageAlt: "A Connecticut small business team collaborating around a laptop",
    cities: ["Hartford", "New Haven", "Stamford", "Bridgeport", "Norwalk", "Danbury"],
    intro:
      "Connecticut's small firms — insurers in Hartford, practices in New Haven, financial boutiques in Stamford — carry enterprise-grade obligations on small-business budgets. Sempresera brings the full standard to Connecticut with on-site support included: monitoring that never sleeps, a 24/7 security operations center, and a help desk that answers.",
    metaTitle: "Managed IT Services in Connecticut | Sempresera",
    metaDescription:
      "Managed IT, Huntress-powered cybersecurity and Microsoft 365 support for Connecticut small businesses — Hartford, New Haven, Stamford and statewide. On-site service included.",
  },
  {
    slug: "rhode-island",
    state: "Rhode Island",
    image: IMAGES.hero_abstract,
    imageAlt: "Professionals working with computers in a small Rhode Island office",
    cities: ["Providence", "Warwick", "Cranston", "Pawtucket", "Newport"],
    intro:
      "Rhode Island may be the smallest state, but its businesses face the same threats and the same expectations as anyone. Sempresera serves firms across Providence, Warwick, Cranston and Newport with the full standard — and because Rhode Island is New England, on-site support is part of the service, not an expensive exception.",
    metaTitle: "Managed IT Services in Rhode Island | Sempresera",
    metaDescription:
      "Managed IT, cybersecurity, Microsoft 365 and 24/7 help desk for Rhode Island small businesses — Providence, Warwick, Newport. Full on-site service, one all-inclusive standard.",
  },
  {
    slug: "new-hampshire",
    state: "New Hampshire",
    image: IMAGES.cybersecurity,
    imageAlt: "A New Hampshire professional working at a desk with a computer",
    cities: ["Manchester", "Nashua", "Concord", "Portsmouth", "Dover"],
    intro:
      "From the tech corridor along the Massachusetts border to practices in Concord and Portsmouth, New Hampshire businesses value straight talk and self-reliance — so do we. Sempresera delivers the full standard across the Granite State with on-site support included: no tiers, no upsells, no fine print.",
    metaTitle: "Managed IT Services in New Hampshire | Sempresera",
    metaDescription:
      "Managed IT, Huntress-powered security and Microsoft 365 support for New Hampshire small businesses — Manchester, Nashua, Concord, Portsmouth. On-site service included.",
  },
  {
    slug: "vermont",
    state: "Vermont",
    image: IMAGES.office_team,
    imageAlt: "A Vermont small business team collaborating around a laptop",
    cities: ["Burlington", "Montpelier", "Rutland", "Brattleboro", "Stowe"],
    intro:
      "Vermont businesses are used to being overlooked by providers who only care about big metros. Sempresera was built for exactly the opposite: firms in Burlington, Montpelier, Rutland and beyond get the same full standard as anyone — with real on-site support, because Vermont is New England too.",
    metaTitle: "Managed IT Services in Vermont | Sempresera",
    metaDescription:
      "Managed IT, cybersecurity, Microsoft 365 and backup for Vermont small businesses — Burlington, Montpelier, Rutland. Full on-site service with one all-inclusive standard.",
  },
  {
    slug: "maine",
    state: "Maine",
    image: IMAGES.server_rack,
    imageAlt: "A small Maine business team at work on laptops",
    cities: ["Portland", "Bangor", "Augusta", "Lewiston", "Biddeford"],
    intro:
      "From Portland's growing professional scene to firms in Bangor and Augusta, Maine businesses deserve IT that respects how far apart things are up here. Sempresera brings the full standard to Maine — 24/7 monitoring, Huntress-powered security, tested backups — with on-site support included as part of our New England home region.",
    metaTitle: "Managed IT Services in Maine | Sempresera",
    metaDescription:
      "Managed IT, cybersecurity, Microsoft 365 and 24/7 help desk for Maine small businesses — Portland, Bangor, Augusta. On-site service included, one all-inclusive standard.",
  },
];
